export default __webpack_public_path__ + "static/media/humberto_jaimes.2fda7963.png";